export default __webpack_public_path__ + "static/blob6-61721a9d596b4f9ebbf39381df65e47b.svg";